import React from 'react';
import { PressTestimonials } from 'components/PressTestimonials/PressTestimonials';

// TODO: remove this component once we fully update modules to use static
//       'PressTestimonials' module. https://classpass.atlassian.net/browse/CRO-1018
export const Press = () => (
  <div className="bg--white">
    <PressTestimonials />
  </div>
);
